import React, {useEffect, useState} from 'react'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'

import {loadModule} from '../../utils/loadModule'
import {useEmailSignUpContext} from './EmailSignUpProvider'

export const MobileLoadable = loadModule(
  async () =>
    import(
      /* webpackChunkName: "EmailMobile" */
      './components/Mobile'
    ),
  {}
)
MobileLoadable.displayName = 'EmailMobileLoadable'

export const DesktopLoadable = loadModule(
  async () =>
    import(
      /* webpackChunkName: "EmailDesktop" */
      './components/Desktop'
    ),
  {}
)
DesktopLoadable.displayName = 'EmailDesktopLoadable'

export const EmailFlow = () => {
  const {isOpen} = useEmailSignUpContext()
  const {isMobile} = useDeviceLayout()

  const [mountChildren, setMountChildren] = useState(isOpen)
  useEffect(() => {
    if (isOpen) setMountChildren(isOpen)
  }, [isOpen])

  // Defer loading child components until opened once
  if (!mountChildren) return null

  return isMobile ? <MobileLoadable /> : <DesktopLoadable />
}
